export interface IGetDevicesPositionsInputDto {
    coordinates: [number, number][];
    from: string;
    to: string;
}
